import React, { useState, useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

import {
  faTachometerAlt,
  faUsers,
  faClipboardList,
  faMoneyBillWave,
  faFileAlt,
  faShoppingCart,
  faBlog,
  faComments,
  faUserTie,
  faSignOutAlt,
  faChevronDown,
  faBars,
  faTimes,
  faBullhorn,
  faServer,
  faUserPlus,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";

import logoImage from "../../images/LandingPageImage/Isancharr.svg";
import NoIndex from "../NoIndex";
import { GlobalContext } from "../../Context/GlobalContext";

const AdminSideNav = ({ Admin, logout, NameAdmin, AdminRole }) => {
  const { baseUrl, config } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const [menuData, setMenuData] = useState([
    {
      id: "1",
      pk_menu_id: "1",
      pk_submenu_id: "1",
      menu_title: "Dashboard",
      menu_icon: "",
      menu_url: "/admin/dashboard",
      menu_type: "MAIN",
      submenus: [
        {
          id: "1",
          submenu_title: "Dashboard",
          submenu_icon: "",
          submenu_url: "/admin/dashboard",
        },
      ],
    },
    {
      id: "5",
      pk_menu_id: "5",
      pk_submenu_id: "5",
      menu_title: "Whatsapp",
      menu_icon: "",
      menu_url: "/admin/whatsapp",
      menu_type: "MAIN",
      submenus: [
        {
          id: "5",
          submenu_title: "Whatsapp",
          submenu_icon: "",
          submenu_url: "/admin/whatsapp",
        },
      ],
    },
    {
      id: "2",
      pk_menu_id: "2",
      pk_submenu_id: "2",
      menu_title: "WhatsApp User",
      menu_icon: "",
      menu_url: "/admin/WhatsAppUser",
      menu_type: "MAIN",
      submenus: [
        {
          id: "2",
          submenu_title: "WhatsApp User",
          submenu_icon: "",
          submenu_url: "/admin/WhatsAppUser",
        },
      ],
    },
    {
      id: "4",
      pk_menu_id: "4",
      pk_submenu_id: "4",
      menu_title: "Whitelist",
      menu_icon: "",
      menu_url: "/admin/Whitelist",
      menu_type: "MAIN",
      submenus: [
        {
          id: "4",
          submenu_title: "Whitelist",
          submenu_icon: "",
          submenu_url: "/admin/whitelist",
        },
      ],
    },
    {
      id: "5",
      pk_menu_id: "5",
      pk_submenu_id: "5",
      menu_title: "Create Client",
      menu_icon: "",
      menu_url: "/admin/createclient",
      menu_type: "MAIN",
      submenus: [
        {
          id: "5",
          submenu_title: "Create Client",
          submenu_icon: "",
          submenu_url: "/admin/createclient",
        },
      ],
    },
  ]);

  const [admin, setadmin] = useState(Admin);

  const fetchAccessCall = async () => {
    setLoading(true);

    try {
      const userDetail = {
        userid: "3",
      };

      const response = await axios.post(
        `${baseUrl}/api/Admin/getUserAccessV1`,
        userDetail,
        config,
      );

      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setMenuData(response.data.response || []);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Failed to load menu data. Please try again.");
      console.error("Error fetching menu data:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (Admin) {
  //     fetchAccessCall();
  //   }
  // }, []);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 text-base font-semibold text-gray-600">
        Loading...
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      <NestedSideNav
        logout={logout}
        Access={menuData}
        NameAdmin={NameAdmin}
        AdminRole={AdminRole}
      />
    </div>
  );
};

const NestedSideNav = ({ Admin, logout, Access, NameAdmin, AdminRole }) => {
  const [activeItem, setActiveItem] = useState("");
  const [expandedItem, setExpandedItem] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1194);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1194);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const path = location.pathname.split("/")[2] || "";

    setActiveItem(path.toLowerCase());
    setIsMobileMenuOpen(false);

    const findParentAndExpand = () => {
      for (const item of Access) {
        if (item?.submenus?.length > 1) {
          const matchingSubItem = item.submenus.find(
            (subItem) =>
              subItem.submenu_url.split("/")[2]?.toLowerCase() ===
              path.toLowerCase(),
          );

          if (matchingSubItem) {
            setExpandedItem(item.pk_menu_id);
            break;
          }
        }
      }
    };

    findParentAndExpand();
  }, [location, Access]);

  const menuIcons = {
    Dashboard: faTachometerAlt,
    Clients: faUsers,
    Orders: faShoppingCart,
    Finance: faMoneyBillWave,
    Logs: faClipboardList,
    Whatsapp: faComments,
    Communication: faComments,
    Employees: faUserTie,
    Blogs: faBlog,
    Campaigns: faBullhorn,
    Techprovider: faServer,
    Whitelist: faListCheck,
    "Create Client": faUserPlus,
  };

  const toggleExpand = (item) => {
    if (item.submenus.length > 1) {
      if (expandedItem === item.pk_menu_id) {
        setExpandedItem(null);
      } else {
        setExpandedItem(item.pk_menu_id);
        navigate(item.submenus[0].submenu_url);
        setActiveItem(item.submenus[0].submenu_url.split("/")[2].toLowerCase());
      }
    }
  };

  const renderNavItem = (item) => {
    const isActive = activeItem === item.menu_url?.split("/")[2]?.toLowerCase();

    const hasSubMenus = item?.submenus?.length > 1;
    const isExpanded = expandedItem === item.pk_menu_id;

    return (
      <li key={item.id}>
        <NoIndex />

        <Link
          to={item.menu_url}
          onClick={(e) => {
            if (hasSubMenus) {
              e.preventDefault();
              toggleExpand(item);
            } else {
              setActiveItem(item.menu_url.split("/")[2].toLowerCase());
              setExpandedItem(null);
              setIsMobileMenuOpen(false);
            }
          }}
          className={`group flex items-center gap-3 rounded-lg px-4 py-3 text-[15px] font-medium transition-all duration-200 ${
            isActive || isExpanded
              ? "bg-[#0B72B9] text-white shadow-sm"
              : "text-gray-600 hover:bg-blue-50 hover:text-[#0B72B9]"
          }`}
        >
          <FontAwesomeIcon
            icon={menuIcons[item.menu_title] || faFileAlt}
            className={`text-[16px] ${
              isActive || isExpanded
                ? "text-white"
                : "text-gray-500 group-hover:text-[#0B72B9]"
            }`}
          />

          <span className="flex-1">{item.menu_title}</span>

          {hasSubMenus && (
            <FontAwesomeIcon
              icon={faChevronDown}
              className={`text-[13px] transition-transform duration-200 ${
                isExpanded ? "rotate-180" : "rotate-0"
              }`}
            />
          )}
        </Link>

        {hasSubMenus && isExpanded && (
          <ul className="mt-1 space-y-1 pl-7">
            {item.submenus.slice(1).map((subItem) => {
              const isSubActive =
                activeItem === subItem.submenu_url.split("/")[2]?.toLowerCase();

              return (
                <li key={subItem.id}>
                  <Link
                    to={subItem.submenu_url}
                    onClick={() => {
                      setActiveItem(
                        subItem.submenu_url.split("/")[2].toLowerCase(),
                      );
                      setIsMobileMenuOpen(false);
                    }}
                    className={`block rounded-md px-4 py-2 text-[14px] font-medium transition-all duration-200 ${
                      isSubActive
                        ? "bg-blue-100 text-[#0B72B9]"
                        : "text-gray-500 hover:bg-blue-50 hover:text-[#0B72B9]"
                    }`}
                  >
                    {subItem.submenu_title}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );
  };

  const MobileTopNavbar = () => (
    <div className="fixed left-0 top-0 z-50 w-full border-b border-gray-200 bg-white shadow-sm">
      <div className="flex h-[64px] items-center justify-between px-4">
        <img src={logoImage} alt="isanchaar" className="h-10" />

        <button
          type="button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-gray-50 text-gray-700"
        >
          <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} />
        </button>
      </div>
    </div>
  );

  return (
    <>
      {isMobile && <MobileTopNavbar />}

      {isMobile && isMobileMenuOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      <nav
        className={`fixed left-0 top-0 z-50 flex h-screen w-[270px] flex-col border-r border-gray-200 bg-white shadow-sm transition-transform duration-300 ${
          isMobile ? "pt-[64px]" : ""
        } ${
          isMobile
            ? isMobileMenuOpen
              ? "translate-x-0"
              : "-translate-x-full"
            : "translate-x-0"
        }`}
      >
        {!isMobile && (
          <div className="px-5 py-5">
            <img src={logoImage} alt="Isancharr" className="h-10" />
            <div className="mt-5 border-b border-gray-200" />
          </div>
        )}

        <div className="flex-1 overflow-y-auto px-3 py-3">
          <ul className="space-y-2">{Access.map(renderNavItem)}</ul>
        </div>

        <button
          type="button"
          onClick={() => setShowLogoutModal(true)}
          className="flex w-full items-center justify-between border-t border-gray-200 bg-gray-50 p-3 text-left transition hover:bg-gray-100"
        >
          <div className="flex h-11 w-11 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600">
            <FontAwesomeIcon icon={faSignOutAlt} />
          </div>

          <div className="flex-1 px-3">
            <p className="m-0 text-[14px] font-bold text-[#0B72B9]">
              {NameAdmin}
            </p>
            <p className="m-0 text-[10px] font-bold text-gray-600">
              {AdminRole}
            </p>
          </div>
        </button>
      </nav>

      {/* Logout Confirmation Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-[430px] rounded-xl bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
              <div>
                <h3 className="text-lg font-bold text-gray-800">
                  Confirm Logout
                </h3>
                <p className="mt-1 text-sm text-gray-500">
                  Please confirm before ending your admin session.
                </p>
              </div>

              <button
                type="button"
                onClick={() => setShowLogoutModal(false)}
                className="rounded-md px-2 py-1 text-2xl leading-none text-gray-500 hover:bg-gray-100"
              >
                ×
              </button>
            </div>

            <div className="px-5 py-5">
              <div className="mb-4 rounded-lg border border-orange-200 bg-orange-50 px-4 py-3">
                <p className="text-sm font-semibold text-orange-700">
                  Are you sure you want to logout?
                </p>
                <p className="mt-1 text-xs text-orange-600">
                  You will need to login again to access the admin dashboard.
                </p>
              </div>

              <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
                <p className="text-xs font-semibold uppercase text-gray-400">
                  Current User
                </p>

                <p className="mt-1 text-[15px] font-bold text-[#0B72B9]">
                  {NameAdmin || "Admin"}
                </p>

                <p className="mt-1 text-xs font-semibold text-gray-600">
                  {AdminRole || "Admin Role"}
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-2 border-t border-gray-200 px-5 py-4">
              <button
                type="button"
                onClick={() => setShowLogoutModal(false)}
                className="rounded-md bg-gray-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-gray-600"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={() => {
                  setShowLogoutModal(false);
                  logout();
                }}
                className="inline-flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700"
              >
                <FontAwesomeIcon icon={faSignOutAlt} />
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AdminSideNav;
